<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import { useLogin } from 'Store';
import CONFIG from 'Config';
import ControlRender from 'Components/ControlRender/ControlRender.vue';
import TheHeader from 'Components/TheHeader/TheHeader.vue';
import TheFooter from 'Components/TheFooter/TheFooter.vue';
import TheModal from 'Components/TheModal/TheModal.vue';
import /* webpackChunkName: ‘AcreCookieConsent’ */ 'AcreComponents/AcreCookieConsent/AcreCookieConsent.umd';

const BannerInvestmentDocuments = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerInvestmentDocuments" */ 'Components/BannerInvestmentDocuments/BannerInvestmentDocuments.vue'
));
const BannerEmailVerification = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerEmailVerification" */ 'Components/BannerEmailVerification/BannerEmailVerification.vue'
));
const BannerMaintenance = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerMaintenance" */ 'Components/BannerMaintenance/BannerMaintenance.vue'
));

const BannerYSAnnouncment = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerYSAnnouncment" */ 'Components/BannerYSAnnouncment/BannerYSAnnouncment.vue'
));

const { isLoggedIn } = useLogin();
</script>

<template>
  <div class="LayoutMain">
    <TheHeader v-bind="$attrs" />
    <ControlRender
      excluded-for-prerender
      when-visible
    >
      <acre-cookie-consent
        :domain="CONFIG.urls.frontend"
        link-href="/company/privacy#we-use-following-tools"
      />
    </ControlRender>
    <ControlRender
      when-logged-in
      excluded-for-prerender
    >
      <BannerInvestmentDocuments v-if="isLoggedIn" />
    </ControlRender>
    <ControlRender
      when-logged-in
      excluded-for-prerender
    >
      <BannerEmailVerification v-if="isLoggedIn" />
    </ControlRender>
    <ControlRender
      when-visible
      excluded-for-prerender
    >
      <BannerMaintenance />
    </ControlRender>
    <ControlRender
      when-visible
      excluded-for-prerender
    >
      <BannerYSAnnouncment />
    </ControlRender>
    <slot />
    <TheFooter />
    <TheModal />
  </div>
</template>
